import { Button } from "@svea/design-system-components-react";
import { formatSsn, P, Stack } from "@sveabank/cc-common";
import Paper from "../../../components/paper";
import type { GuarantorName } from "../../../types/guarantor";
import GuarantorInfoBox from "../add-guarantor-box/guarantor-info-box";

type Props = {
	name: GuarantorName;
	ssn: string;
	onRemove: () => void;
	descriptionText: string;
};

const GuarantorConfirmInfo = ({ name, ssn, onRemove, descriptionText }: Props) => (
	<>
		<P>{descriptionText}</P>
		<Paper>
			<Stack direction="row" justify="between">
				<GuarantorInfoBox
					firstName={name?.firstNames}
					lastName={name?.lastNames}
					ssn={formatSsn(ssn)}
				/>
				<Button variant="icon" onPress={onRemove} icon="trash" aria-label="Ta bort" />
			</Stack>
		</Paper>
	</>
);

export default GuarantorConfirmInfo;
